import { useEventBus } from "@vueuse/core";
import type { ZoomTransform } from "d3";
import { inject, provide, type InjectionKey, type Ref } from "vue";
import type { SVGDimension } from "../interfaces";
import type { SVGMouse } from "./mouse-position";

// export class SVGEventEmitter extends EventTarget {}

const BusKey = Symbol();

export function SVGEventEmitter() {
	const emitter = useEventBus(BusKey);
	return emitter;
}

type SVGContainer = {
	dimension: Ref<SVGDimension>;
	contentDimension: Ref<SVGDimension>;
	mouse: SVGMouse;
	transform: Readonly<Ref<ZoomTransform>>;
	setTransform: (transform: ZoomTransform) => void;
	clickOutsideEvent: ReturnType<typeof SVGEventEmitter>;
};

const symbol: InjectionKey<SVGContainer> = Symbol();

export const provideSVGContainer = (project: SVGContainer) => {
	provide(symbol, project);
};

export const useSVGContainer = () => {
	const container = inject(symbol);
	if (!container) throw new Error("Must be child of svg container");

	return container;
};
